import { Key } from 'antd/lib/table/interface';
import { ColumnFilterItem } from 'antd/es/table/interface';
import { useTranslation } from 'react-i18next';
import { CheckboxChangeEvent } from 'antd/es/checkbox';
import { Checkbox, Input } from 'antd';
import { Button } from 'syngenta-digital-cropwise-react-ui-kit';
import React, { ChangeEvent, useState } from 'react';
import SearchIcon from './SearchIcon';
import includes from 'lodash/includes';

type CustomFilterDropdownType = {
  setSelectedKeys: (selectedKeys: Key[]) => void;
  filters?: ColumnFilterItem[];
  clearFilters?: () => void;
  selectedKeys: Key[];
  onApply: (selectedKeys: Key[]) => void;
  search?: boolean;
};

export const CustomFilterDropdown = ({
  setSelectedKeys,
  filters,
  clearFilters,
  selectedKeys,
  onApply,
  search = false,
}: CustomFilterDropdownType) => {
  const [searchTerm, setSearchTerm] = useState<string>('');

  const { t } = useTranslation();
  const handleOnChange = (e: CheckboxChangeEvent) =>
    setSelectedKeys(
      selectedKeys.includes(e.target.value)
        ? selectedKeys.filter((key: any) => key !== e.target.value)
        : [...selectedKeys, e.target.value],
    );

  const handleOnChangeSearch = (e: ChangeEvent<HTMLInputElement>) => setSearchTerm(e.target.value);

  return (
    <div className="flex flex-col w-230px min-h-110px justify-between">
      {search && (
        <div className="flex flex-col p-12 border-b-1 border-neutral-20">
          <Input
            data-testid="search-input"
            size={'small'}
            className="rounded-4"
            placeholder={`${t('Integration.search')}`}
            onChange={handleOnChangeSearch}
            suffix={<SearchIcon />}
            value={searchTerm}
          />
        </div>
      )}
      <div className="flex flex-col p-12">
        {filters
          ?.filter((item) =>
            includes(item?.text?.toString().toLowerCase(), searchTerm.toLowerCase()),
          )
          .map((item: any) => {
            const itemValue = item.value as string;
            return (
              <div key={itemValue} className="pb-6">
                <Checkbox
                  onChange={handleOnChange}
                  value={itemValue}
                  checked={selectedKeys.includes(itemValue)}
                  data-cy={`custom-dropdown-checkbox-${itemValue}`}
                >
                  {item.text}
                </Checkbox>
              </div>
            );
          })}
      </div>
      <div className="flex justify-between p-12">
        <Button size="small" onClick={clearFilters} data-testid="reset-button">
          {t('resource-mapper.reset')}
        </Button>
        <Button
          size="small"
          color="green"
          className="bg-green-60 text-neutral-00 hover:bg-green-70 focus:bg-green-70 hover:text-neutral-00 focus:text-neutral-00"
          onClick={() => {
            setSearchTerm('');
            onApply(selectedKeys);
          }}
          data-cy="custom-dropdown-apply"
          data-testid="apply-button"
        >
          {t('resource-mapper.apply')}
        </Button>
      </div>
    </div>
  );
};
